import { put, call } from 'lib/redux';
import history from 'store/CreateHistory';
import { decodeAndDecrypt } from 'utils/app.utils';
import getReportDetailsService from 'services/getReportDetails.service';
import { INITIALIZATION_VECTOR, KEY } from 'constants/AppConstants';
import getReportAddressesService from 'services/getReportAddresses.service';
import { LOAD_SITEMAP_DATA_ERROR, LOAD_SITEMAP_DATA_SUCCESS, LOADING_SITEMAP_DATA } from 'constants/ActionTypes';
import { logError } from 'utils/logger.utils';

export default function* loadSitemapPageSaga() {
  try {
    yield put({ type: LOADING_SITEMAP_DATA });

    const { location: { pathname, search, state } } = history;
    const query = new URLSearchParams(search);
    const encryptedOrderId = query.get('id');
    const orderSignature = query.get('signature'); // #genai

    const orderId = yield call(decodeAndDecrypt, encryptedOrderId, KEY, INITIALIZATION_VECTOR);

    const reportAddressesResponse = yield call(getReportAddressesService, orderId, orderSignature);
    if (!reportAddressesResponse.ok) {
      const error = new Error(reportAddressesResponse.json.errorDescription);
      error.errorCode = reportAddressesResponse.json.errorCode;
      throw error;
    }
    const { json: reportAddresses } = reportAddressesResponse;

    const focusedReportId = state?.reportId;
    const reportIdForDetails = focusedReportId || reportAddresses[0]?.reportId;
    const focusedAddress = reportAddresses.find(({ reportId }) => reportId === reportIdForDetails) || reportAddresses[0];
    const signedReportId = focusedAddress?.signedReportId; // #genai
    const reportDetailsResponse = yield call(getReportDetailsService, reportIdForDetails, signedReportId);
    if (!reportDetailsResponse.ok) {
      const error = new Error(reportDetailsResponse.json.errorDescription);
      error.errorCode = reportDetailsResponse.json.errorCode;
      throw error;
    }
    const { json: reportDetails } = reportDetailsResponse;

    history.replace(pathname + search, {});
    const focusedPointIndex = Math.max(reportAddresses?.findIndex(({ reportId }) => focusedReportId && reportId === focusedReportId), 0);

    yield put({
      type: LOAD_SITEMAP_DATA_SUCCESS, reportDetails, focusedPointIndex, reportAddresses,
    });
  } catch (error) {
    logError('Error in loadSitemapPageSaga', {
      error: error.message,
      errorCode: error.errorCode,
    });
    yield put({ type: LOAD_SITEMAP_DATA_ERROR });
  }
}
